import Vue from 'vue'
import Vuex from 'vuex'

// 登录
import login from "./modules/login";
// 文章管理
import article from './modules/article';
// 新闻动态标题页
import myZs6 from './modules/myZs6';

Vue.use(Vuex)

export default new Vuex.Store({
    state:{
    },
    mutations:{

    },
    actions:{

    },
    modules:{
        login, //登录
        article, // 文章管理
        myZs6,//新闻动态标题页
    }
})